import { render, staticRenderFns } from "./ProductEleven.vue?vue&type=template&id=bda25c9c&"
import script from "./ProductEleven.vue?vue&type=script&lang=js&"
export * from "./ProductEleven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda25c9c')) {
      api.createRecord('bda25c9c', component.options)
    } else {
      api.reload('bda25c9c', component.options)
    }
    module.hot.accept("./ProductEleven.vue?vue&type=template&id=bda25c9c&", function () {
      api.rerender('bda25c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductEleven.vue"
export default component.exports